<template>
    <span :class="iconClass" v-text="name"></span>
</template>

<script>
    export default {
        name: "Icon",
        props: {
            name: {
                type: String,
            }
        },
        computed: {
            iconClass() {
                return 'icon-' + this.name;
            }
        }
    }
</script>

<style scoped>

</style>